import { http } from '../index';
import { downloadFileFromBytes, getFileNameFromContentDispositionString } from '../helpers';

export const getMoodleSystemCourseCatalog = courseSystemId =>
  http
    .get('/moodle/course-catalog/system', { params: { courseSystemId } })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getMoodleTrainingPartCourseCatalog = (trainingPartCode, trainingPartId) =>
  http
    .get('/moodle/course-catalog/training-part', {
      params: {
        trainingPartCode,
        ...(trainingPartId ? { trainingPartId } : {}),
      },
    })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getMoodleTrainingPartLanguageLinks = trainingPartId =>
  http
    .get(`/moodle/training-parts/${trainingPartId}/language-links`)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const replaceMoodleTrainingPartLanguageLinks = (trainingPartId, data) =>
  http
    .put(`/moodle/training-parts/${trainingPartId}/language-links`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getLanguageManagerInventory = params =>
  http
    .get('/moodle/language-manager', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const refreshLanguageManager = data =>
  http
    .post('/moodle/language-manager/refresh', data)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const applySafeLanguageManagerChanges = data =>
  http
    .post('/moodle/language-manager/apply-safe', data)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const attachLanguageManagerCourse = (trainingPartId, language, moodleCourseId) =>
  http
    .post(`/moodle/language-manager/training-parts/${trainingPartId}/languages/${language}/attach`, {
      moodleCourseId,
    })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const replaceLanguageManagerCourse = (trainingPartId, language, moodleCourseId) =>
  http
    .put(`/moodle/language-manager/training-parts/${trainingPartId}/languages/${language}`, {
      moodleCourseId,
    })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getLtiTrainingSessionLaunchPreflight = trainingSessionId =>
  http
    .get('/lti/launch-training-session-preflight', { params: { trainingSessionId } })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

/**
 * Admin/raw: issue Moodle certificate PDF from trusted eTrat pass payload.
 * Prefer downloadTrainingSessionCertificateFromEtrat for student UI.
 */
export const issueCertificateFromEtrat = (data, format = 'pdf') => {
  const isJson = format === 'json';
  return http
    .post('/moodle/certificates/issue-from-etrat', data, {
      params: isJson ? { format: 'json' } : undefined,
      responseType: isJson ? 'json' : 'blob',
    })
    .then(res => {
      if (isJson) {
        return res.data;
      }
      const filename = getFileNameFromContentDispositionString(res);
      downloadFileFromBytes(res.data, filename, '', true);
      return true;
    })
    .catch(error => error.response?.data || { error: true });
};

export const getTrainingPartPreviewPreflight = trainingPartId =>
  http
    .get('/lti/launch-training-part-preflight', { params: { trainingPartId } })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const syncMoodleTrainingPartLanguages = trainingPartId =>
  http
    .post(`/training-parts/${trainingPartId}/sync-lms-languages`)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getMoodleTrainingPartLanguageStatus = trainingPartId =>
  http
    .get(`/training-parts/${trainingPartId}/lms-language-status`)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });

export const getMoodleNonSynchronizedStatuses = params => {
  return http
    .get('/moodle/sync/course-results/non-synchronized', {
      params,
    })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });
};

export const reconcileMoodleCourseStatuses = data => {
  return http
    .post('/moodle/sync/course-results/reconcile', data)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });
};

export const startMoodleReconcileRun = data => {
  return http
    .post('/moodle/sync/course-results/reconcile/start', data)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });
};

export const getMoodleReconcileRun = runId => {
  return http
    .get(`/moodle/sync/course-results/reconcile/runs/${runId}`)
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });
};

export const getMoodleSyncHealthDashboard = params => {
  return http
    .get('/moodle/sync/course-results/health-dashboard', {
      params,
    })
    .then(res => res.data)
    .catch(error => error.response?.data || { error: true });
};
